// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../public/icons/rectangle.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#nav-icon1,
#nav-icon2,
#nav-icon3,
#nav-icon4 {
  width: 40px;
  height: 20px;
  position: relative;
  transform: rotate(0deg);
  transition: 0.5s ease-in-out;
  cursor: pointer;
}

#nav-icon1 span,
#nav-icon3 span,
#nav-icon4 span {
  display: block;
  position: absolute;
  height: 4px;
  width: 100%;
  background: #6b7280;
  border-radius: 9px;
  opacity: 1;
  left: 0;
  transform: rotate(0deg);
  transition: 0.25s ease-in-out;
}

#nav-icon1 span:nth-child(1) {
  top: 0px;
}

#nav-icon1 span:nth-child(2) {
  top: 9px;
}

#nav-icon1 span:nth-child(3) {
  top: 18px;
}
.header-one {
  font-size: 2em;
  font-weight: bold;
  margin: 1em 0;
}
.header-two {
  font-size: 1.5em;
  font-weight: bold;
  margin: 1em 0;
}
.header-three {
  font-size: 1.2em;
  font-weight: bold;
  margin: 1em 0;
}
.header-four {
  font-size: 1.1em;
  font-weight: bold;
  margin: 1em 0;
}
.header-five {
  font-size: 1em;
  font-weight: bold;
  margin: 1em 0;
}
.header-six {
  font-size: 0.85em;
  font-weight: bold;
  margin: 1em 0;
}
.blockquote {
  font-style: italic;
  margin: 1em 0;
  padding-left: 1em;
  border-left: 4px solid gray;
}
.code-block {
  background-color: #f7f7f7;
  padding: 10px;
  border-radius: 4px;
}
.unordered-list-item {
  list-style-type: disc;
  margin-left: 1em;
}
#container-editor a {
  color: #2d67d2 !important;
}
#container-editor a:hover {
  color: #528de0 !important;
}
.ordered-list-item {
  list-style-type: decimal;
  margin-left: 1em;
}
.section {
  margin: 1em 0;
  padding: 1em;
  background-color: #f0f0f0;
}
.article {
  margin: 1em 0;
  padding: 1em;
  background-color: #e0e0e0;
}
#nav-icon1.open span:nth-child(1) {
  top: 9px;
  transform: rotate(135deg);
}

#nav-icon1.open span:nth-child(2) {
  opacity: 0;
  left: 60px;
}

#nav-icon1.open span:nth-child(3) {
  top: 9px;
  transform: rotate(-135deg);
}

.menu-wrapper {
  width: 250px;
  background-color: rgba(255, 255, 255, 1);
  margin-left: -450px;
  opacity: 0;
  -webkit-box-shadow: 10px 10px 6px -8px rgba(161, 136, 119, 0.7);
  transition: all 0.3s ease-in-out;
  border-radius: 2px;
  border-right: 1px solid rgba(0, 0, 0, 0.2);
  border-bottom: 1px solid rgba(0, 0, 0, 0.2);
}

.menu-open {
  margin-left: -450px;
  opacity: 1;
}

.maplibregl-ctrl-attrib-inner {
  display: none;
}

.maplibregl-ctrl-bottom-right {
  display: none;
}
.menu-toggle {
  cursor: pointer;
  z-index: 1000;
  margin: 20px;
  padding: 0px;
  height: 50px;
  width: 50px;
  font-size: 20px;
  color: rgba(0, 0, 0, 0.5);
  font-weight: bold;
  border-radius: 50%;
  background-color: rgba(255, 255, 255, 0.8);
  transform: rotate(0deg);
  transition: all 0.2s ease-in;
  border: 0 none;
}

.menu-toggle:hover {
  cursor: pointer;
  transform: scale(1.1) rotate(0deg);
  -webkit-box-shadow: 10px 2px 8px -8px rgba(179, 164, 139, 0.6);
}

.menu-toggle:focus {
  cursor: pointer;
  outline: 0 none;
}

.links-wrapper {
  margin: 10px;
  padding: 10px;
  text-align: right;
  opacity: 1;
  transition: all 0.7s ease-out;
  transition-delay: 0.1s;
  letter-spacing: 0px;
}

.links-wrapper-closed {
  padding-top: 10px;
  opacity: 0;
  letter-spacing: -10px;
}

.link-list {
  padding-top: 30px;
  padding-right: 25px;
  padding-left: 25px;
}

.link-list li {
  /* list-style-type: none; */
  text-transform: uppercase;
  margin: 0;
  margin-bottom: 30px;
  padding: 3px;
}

.link-list a {
  text-decoration: none;
  color: rgba(0, 0, 0, 0.804);
  transition: color 0.3s ease;
}

.social-wrapper a {
  font-size: 24px;
  color: rgba(0, 0, 0, 0.5);
  transition: color 0.3s ease;
}

.social-wrapper a:hover {
  color: rgba(0, 0, 0, 0.3);
}

.social-open {
  opacity: 1;
  transition: opacity 0.7s ease-out;
  transition-delay: 0.3s;
}

.social-closed {
  opacity: 0;
  transition: opacity 0.3s ease-out;
}

.logo {
  height: 6em;
  padding: 1.5em;
  will-change: filter;
  transition: filter 300ms;
}

.logo:hover {
  filter: drop-shadow(0 0 2em #646cffaa);
}

.logo.react:hover {
  filter: drop-shadow(0 0 2em #61dafbaa);
}

@keyframes logo-spin {
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
}

@media (prefers-reduced-motion: no-preference) {
  a:nth-of-type(2) .logo {
    animation: logo-spin infinite 20s linear;
  }
}

.card {
  padding: 2em;
}

.read-the-docs {
  color: #888;
}

.border-date-error {
  border-radius: 8px;
  border: #f05252 1px solid !important;
}

.MuiInputBase-root {
  background-color: "#FEE2E2 !important";
}

.mui-datepicker {
  --mui-datepicker-color: red !important;
}

.gradient-color {
  background: linear-gradient(
    0deg,
    #000 0%,
    rgba(0, 0, 0, 0.75) 48.44%,
    rgba(0, 0, 0, 0.4) 75.52%,
    rgba(0, 0, 0, 0) 100%
  ) !important;
}

.image-container {
  position: relative;
}

.image-container::after {
  border-end-end-radius: 24px;
  border-end-start-radius: 24px;
  content: "";
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 62px;
  background: linear-gradient(
    to bottom,
    rgba(255, 255, 255, 0),
    rgba(0, 0, 0, 1)
  );
}

.gradient-overlay::after {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(
    0deg,
    #000 0%,
    rgba(0, 0, 0, 0.75) 48.44%,
    rgba(0, 0, 0, 0.4) 75.52%,
    rgba(0, 0, 0, 0) 100%
  );
  border-radius: 0.75rem;
  pointer-events: none;
}

.force-0 {
  margin: 0 !important;
}

.radius {
  border-radius: 40px;
}

.gerdali {
  border-radius: 16px !important;
}

.banner-image-filter {
  background-blend-mode: plus-darker;
}

.banner-image-filter-content {
  mix-blend-mode: plus-darker;
}

.step-item {
  border-inline-start-width: 1px;
}

.svg-color-transition {
  transition: fill 3.3s ease;
}

.fade-enter {
  opacity: 0;
  z-index: 1;
}

.fade-enter-active {
  opacity: 1;
  transition: opacity 300ms ease-in;
}

.fade-exit {
  opacity: 1;
}

.fade-exit-active {
  opacity: 0;
  transition: opacity 300ms ease-in;
}

.aspect-ratio-16-9 {
  position: relative;
  width: 100%;
  padding-top: 52.25%;
}

.aspect-ratio-16-9-store-image {
  position: relative;
  width: 100%;
  padding-top: 20.5%;
}

.mask-svg {
  -webkit-mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  -webkit-mask-position: center;
  -webkit-mask-size: cover;
  -webkit-mask-repeat: no-repeat;

  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  mask-position: center;
  mask-size: cover;
  mask-repeat: no-repeat;
}

.mask-svg.shrinkgrow {
  animation: mask_svg_shrinkgrow_keys 3s linear 0s normal forwards;
  -moz-animation: mask_svg_shrinkgrow_keys 3s linear 0s normal forwards;
  -webkit-animation: mask_svg_shrinkgrow_keys 3s linear 0s normal forwards;
}

@keyframes mask_svg_shrinkgrow_keys {
  0% {
    -webkit-mask-position: center;
    -webkit-mask-size: cover;
    mask-position: 0px 0px;
    mask-size: 10000px 0px;
    animation-timing-function: ease-in-out;
  }

  20% {
    -webkit-mask-position: center;
    -webkit-mask-size: cover;
    mask-position: 0px 0px;
    mask-size: 10000px 0px;
    animation-timing-function: ease-in-out;
  }

  50% {
    -webkit-mask-position: center;
    -webkit-mask-size: cover;
    mask-position: 0px 0px;
    mask-size: 10000px 380px;
    animation-timing-function: ease-in-out;
  }

  100% {
    -webkit-mask-position: center;
    -webkit-mask-size: cover;
    mask-position: 0px 0px;
    mask-size: 10000px 10000px;
    animation-timing-function: ease-in-out;
  }
}

#search-dropdown:focus {
  border: 1px solid #d1d5db;
  outline: none;
  border-radius: 10px 0px 0px 10px;
  background-color: #f3f4f6;
}

#search-dropdown {
  border: 1px solid #d1d5db;
}

.full-screen {
  z-index: 2;
  height: 100vh !important;
  background-color: #a59e9e4a;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  pointer-events: none;
}

.min-h-screen-90px {
  min-height: calc(100vh - 90px);
}

.max-h-screen-150px {
  max-height: calc(100vh - 150px);
}

.rounded-bb-ends {
  position: relative;
}

.rounded-bb-ends::after {
  content: "";
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 4px;
  background: #477cd1;
  border-bottom-left-radius: 80px;
  border-bottom-right-radius: 80px;
  border-top-right-radius: 80px;
  border-top-left-radius: 80px;
}

.min-h-screen-min {
  min-height: calc(100vh + 150px);
}

.my-confirm-button {
  border: none !important;
  border-radius: 8px !important;
  outline-style: none !important;
  color: white !important;
  outline: none !important;
}

.my-confirm-button:focus {
  border: none !important;
  outline: none !important;
}

.my-cancel-button {
  border-radius: 8px !important;
  color: #1f2a37 !important;
  border: #e5e7eb 1px solid !important;
}

.swal2-popup .swal2-styled:focus {
  box-shadow: none !important;
}

.width-full-mobile-cheque {
  width: calc(100vw - 50px);
}

.w-dashboard {
  width: calc(100vw - 50px);
}

@media screen and (min-width: 536px) {
  .w-dashboard-table-mobile {
    width: calc(100vw - 300px) !important;
    max-width: 1800px !important;
    margin-top: 32px !important;
    margin-inline: auto;
    /* background-color: blue; */
  }
}

@media screen and (max-width: 768px) {
  .w-dashboard-table-mobile {
    width: calc(100vw) !important;
    /* background-color: blue; */
  }
}

@media screen and (min-width: 536px) {
  .w-dashboard-table-mobile-header {
    width: calc(100vw - 400px) !important;
    max-width: 1800px !important;
    /* margin-top: 32px !important; */
    /* background-color: blue; */
  }
}

@media screen and (max-width: 768px) {
  .w-dashboard-table-mobile-header {
    width: calc(90vw) !important;
    /* background-color: blue; */
  }
}

@media screen and (min-width: 536px) {
  .w-dashboard-dashbord-step {
    width: calc(100vw - 300px);
    max-width: 1200px;
    /* background-color: blue; */
  }
}

@media screen and (max-width: 768px) {
  .w-dashboard-dashbord-step {
    width: calc(90vw);
    /* background-color: blue; */
  }
}

.fulltext {
  white-space: nowrap;
}

.truncatetext:hover + .fulltext,
.fulltext:hover {
  display: inline;
  white-space: normal;
  white-space: nowrap;
}

.truncatetext:hover {
  white-space: nowrap;
}

.p-checkbox-icon {
  color: white;
}

.p-checkbox-box {
  border: #c3c3c3 1px solid !important;
  border-radius: 6px;
}

.p-checkbox .p-highlight {
  color: #1d65f2;
  background-color: #1d65f2 !important;
  border: none !important;
  border-radius: 6px;
}

.p-radiobutton-box:focus {
  border: none !important;
}

.p-radiobutton-box {
  background-color: #e1e1e1 !important;
}

.p-radiobutton-icon {
  background-color: rgb(29, 89, 228) !important;
  background-image: none !important;
}

.p-highlight {
  border: none !important;
}

.p-dropdown-items-wrapper {
  background-color: #e7e7e73b !important; /* Light gray background */
  color: #000000; /* Dark text color */
  border-radius: 8px !important;
  padding-inline: 10px !important;
  border-bottom: 3px;
}

.p-dropdown-items-wrapper:hover {
  background-color: #e7e7e73b !important; /* Slightly darker on hover */
  color: #000; /* Black text color on hover */
}

.p-focus {
  border: none !important;
}

.p-column-header-content {
  display: flex;
  align-items: start;
  justify-content: center;
}

@keyframes pulseBorder {
  0% {
    border: 2px solid transparent;
  }

  50% {
    border: 3px solid #3498db;
  }

  100% {
    border: 2px solid transparent;
  }
}

.animated-border {
  animation: pulseBorder 1s infinite;
  border-radius: 8px;
}

tr td:not(.p-selection-column):first-child {
  padding: 0;
}

th {
  text-align: center;
  white-space: nowrap;
}

@keyframes wink {
  0%,
  100% {
    opacity: 1;
    scale: 1.1;
  }

  50% {
    opacity: 0.8;
    scale: 0.9;
  }
}

.animate-wink {
  animation: wink 1.5s infinite;
}

.center-text-input {
  text-align: center;
}

.p-paginator-element svg {
  transform: rotate(180deg);
}

[data-p-frozen-column="true"] {
  left: 0px !important;
}

.test-gradient {
  background: linear-gradient(180deg, #ffdc97 -25%, #ffea30 100%);
}

.tooltip {
  position: relative;
  display: inline-block;
}

.tooltip .tooltiptext {
  visibility: hidden;
  width: fit-content;
  white-space: nowrap;
  background-color: black;
  color: #fff;
  text-align: center;
  border-radius: 6px;
  padding: 5px 0;
  position: absolute;
  z-index: 1;
}

.tooltip:hover .tooltiptext {
  visibility: visible;
}

.scrollable-container {
  overflow-x: auto;
  white-space: nowrap;
  cursor: grab;
}

.scrollable-container:active {
  cursor: grabbing;
}

.creditor-loan-component {
  display: inline-block;
}

.height-hc {
  height: 52px !important;
  font-size: 20px !important;
  font-weight: 400 !important;
}

.no-border {
  border: none;
  border-color: #bbbbbb !important;
  padding-top: 0 !important;
  padding-bottom: 0 !important;
  margin-top: 30px !important;
  color: #bbbbbb !important;
  width: 60px !important;
  height: 60px !important;
}

.title-padding {
  padding-top: 0 !important;
  margin-top: 0 !important;
  font-size: 16px !important;
  font-weight: 400px !important;
  color: #6b7280 !important;
}

.input-no-focus-border:focus {
  outline: none;
  /* border: none; */
  box-shadow: none;
  border-bottom: 1px black solid !important;
}

.h5-important {
  height: 5px !important;
}

.noselect {
  -webkit-touch-callout: none; /* iOS Safari */
  -webkit-user-select: none; /* Safari */ /* Konqueror HTML */ /* Old versions of Firefox */ /* Internet Explorer/Edge */
  user-select: none; /* Non-prefixed version, currently
                                  supported by Chrome, Edge, Opera and Firefox */
}

.selector {
  -webkit-user-drag: none;
  user-select: none;
  -moz-user-select: none;
  -webkit-user-select: none;
  -ms-user-select: none;
}

@keyframes wink-color {
  0%,
  100% {
    color: #477cd1;
  }

  50% {
    color: #031203;
  }
}

.hover-wink-color:hover {
  animation: wink-color 0.5s infinite;
}

@media screen and (min-width: 536px) {
  .w-dashboard-table-mobile-in-tasvie {
    width: calc(100vw - 300px) !important;
    max-width: 1400px;
  }
}

@media screen and (max-width: 768px) {
  .w-dashboard-table-mobile-in-tasvie {
    width: calc(100vw);
    /* background-color: blue; */
  }
}

.forceheight {
  height: 60px !important;
  font-weight: 900 !important;
  font-size: large !important;
}

.borderforce {
  border: red 2px solid !important;
}

.border-radius-force {
  border-radius: 8rem !important;
}

.h-fullll {
  height: 100% !important;
}

.custom-dropdown {
  width: 100%;
  border: 2px solid #d4d4d4 !important;
  border-radius: 8px;
  font-size: 16px;
}

.custom-panel .p-dropdown-item {
  color: #333;
  padding: 10px;
  transition: background-color 0.3s ease;
  border-bottom: #a2b8e4 1px solid !important;
}

.custom-panel .p-dropdown-item.p-highlight,
.custom-panel .p-dropdown-item:hover {
  background-color: #93bde4;
  color: #fff;
  border-bottom: #315c85 5px solid !important;
}

@keyframes gradientBG {
  0% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0% 50%;
  }
}

.animated-bg {
  background: linear-gradient(
    60deg,
    #b9d4fc,
    #ffffff,
    #ddedfe,
    #b9d4fc,
    #ffffff
  );
  background-size: 300% 300%;
  animation: gradientBG 3s ease infinite;
}

.carousel-container {
  display: flex;
  justify-content: center;
  align-items: center;
  perspective: 1000px;
  transform-style: preserve-3d;
  transition: transform 0.5s;
  position: relative;
  height: 300px; /* Adjust height as needed */
}

.carousel-item {
  position: absolute;
  transform-origin: center;
  transform: rotateY(calc(var(--index) * 90deg)) translateZ(300px);
}

@media print-add {
  body * {
    visibility: hidden;
  }

  .print-add-content,
  .print-add-content * {
    visibility: visible;
  }

  .print-add-content {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
  }
}

.p-multiselect-clear-icon {
  right: 90% !important;
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;;;;EAIE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAIlB,uBAAuB;EAIvB,4BAA4B;EAC5B,eAAe;AACjB;;AAEA;;;EAGE,cAAc;EACd,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,UAAU;EACV,OAAO;EAIP,uBAAuB;EAIvB,6BAA6B;AAC/B;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE,SAAS;AACX;AACA;EACE,cAAc;EACd,iBAAiB;EACjB,aAAa;AACf;AACA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,aAAa;AACf;AACA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,aAAa;AACf;AACA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,aAAa;AACf;AACA;EACE,cAAc;EACd,iBAAiB;EACjB,aAAa;AACf;AACA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,aAAa;AACf;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,iBAAiB;EACjB,2BAA2B;AAC7B;AACA;EACE,yBAAyB;EACzB,aAAa;EACb,kBAAkB;AACpB;AACA;EACE,qBAAqB;EACrB,gBAAgB;AAClB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,wBAAwB;EACxB,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,YAAY;EACZ,yBAAyB;AAC3B;AACA;EACE,aAAa;EACb,YAAY;EACZ,yBAAyB;AAC3B;AACA;EACE,QAAQ;EAIR,yBAAyB;AAC3B;;AAEA;EACE,UAAU;EACV,UAAU;AACZ;;AAEA;EACE,QAAQ;EAIR,0BAA0B;AAC5B;;AAEA;EACE,YAAY;EACZ,wCAAwC;EACxC,mBAAmB;EACnB,UAAU;EACV,+DAA+D;EAC/D,gCAAgC;EAChC,kBAAkB;EAClB,0CAA0C;EAC1C,2CAA2C;AAC7C;;AAEA;EACE,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;AACA;EACE,eAAe;EACf,aAAa;EACb,YAAY;EACZ,YAAY;EACZ,YAAY;EACZ,WAAW;EACX,eAAe;EACf,yBAAyB;EACzB,iBAAiB;EACjB,kBAAkB;EAClB,0CAA0C;EAC1C,uBAAuB;EACvB,4BAA4B;EAC5B,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,kCAAkC;EAClC,8DAA8D;AAChE;;AAEA;EACE,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,iBAAiB;EACjB,UAAU;EACV,6BAA6B;EAC7B,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,UAAU;EACV,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,2BAA2B;EAC3B,yBAAyB;EACzB,SAAS;EACT,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,qBAAqB;EACrB,2BAA2B;EAC3B,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,UAAU;EACV,iCAAiC;EACjC,sBAAsB;AACxB;;AAEA;EACE,UAAU;EACV,iCAAiC;AACnC;;AAEA;EACE,WAAW;EACX,cAAc;EACd,mBAAmB;EACnB,wBAAwB;AAC1B;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE;IACE,wCAAwC;EAC1C;AACF;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,oCAAoC;AACtC;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE;;;;;;cAMY;AACd;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,2BAA2B;EAC3B,6BAA6B;EAC7B,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,WAAW;EACX,YAAY;EACZ;;;;GAIC;AACH;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT;;;;;;GAMC;EACD,sBAAsB;EACtB,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,UAAU;EACV,UAAU;AACZ;;AAEA;EACE,UAAU;EACV,iCAAiC;AACnC;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;EACV,iCAAiC;AACnC;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,2DAAwD;EACxD,6BAA6B;EAC7B,wBAAwB;EACxB,8BAA8B;;EAE9B,mDAAgD;EAChD,qBAAqB;EACrB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,gEAAgE;EAChE,qEAAqE;EACrE,wEAAwE;AAC1E;;AAEA;EACE;IACE,6BAA6B;IAC7B,wBAAwB;IACxB,sBAAsB;IACtB,sBAAsB;IACtB,sCAAsC;EACxC;;EAEA;IACE,6BAA6B;IAC7B,wBAAwB;IACxB,sBAAsB;IACtB,sBAAsB;IACtB,sCAAsC;EACxC;;EAEA;IACE,6BAA6B;IAC7B,wBAAwB;IACxB,sBAAsB;IACtB,wBAAwB;IACxB,sCAAsC;EACxC;;EAEA;IACE,6BAA6B;IAC7B,wBAAwB;IACxB,sBAAsB;IACtB,0BAA0B;IAC1B,sCAAsC;EACxC;AACF;;AAEA;EACE,yBAAyB;EACzB,aAAa;EACb,gCAAgC;EAChC,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,UAAU;EACV,wBAAwB;EACxB,2BAA2B;EAC3B,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,SAAS;EACT,OAAO;EACP,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,WAAW;EACX,WAAW;EACX,mBAAmB;EACnB,+BAA+B;EAC/B,gCAAgC;EAChC,6BAA6B;EAC7B,4BAA4B;AAC9B;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,uBAAuB;EACvB,6BAA6B;EAC7B,8BAA8B;EAC9B,uBAAuB;EACvB,wBAAwB;AAC1B;;AAEA;EACE,uBAAuB;EACvB,wBAAwB;AAC1B;;AAEA;EACE,6BAA6B;EAC7B,yBAAyB;EACzB,oCAAoC;AACtC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE;IACE,qCAAqC;IACrC,4BAA4B;IAC5B,2BAA2B;IAC3B,mBAAmB;IACnB,4BAA4B;EAC9B;AACF;;AAEA;EACE;IACE,6BAA6B;IAC7B,4BAA4B;EAC9B;AACF;;AAEA;EACE;IACE,qCAAqC;IACrC,4BAA4B;IAC5B,iCAAiC;IACjC,4BAA4B;EAC9B;AACF;;AAEA;EACE;IACE,4BAA4B;IAC5B,4BAA4B;EAC9B;AACF;;AAEA;EACE;IACE,0BAA0B;IAC1B,iBAAiB;IACjB,4BAA4B;EAC9B;AACF;;AAEA;EACE;IACE,iBAAiB;IACjB,4BAA4B;EAC9B;AACF;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;EAEE,eAAe;EACf,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,oCAAoC;EACpC,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,oCAAoC;EACpC,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,6CAA6C;EAC7C,iCAAiC;AACnC;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,sCAAsC,EAAE,0BAA0B;EAClE,cAAc,EAAE,oBAAoB;EACpC,6BAA6B;EAC7B,+BAA+B;EAC/B,kBAAkB;AACpB;;AAEA;EACE,sCAAsC,EAAE,6BAA6B;EACrE,WAAW,EAAE,8BAA8B;AAC7C;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE;IACE,6BAA6B;EAC/B;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,6BAA6B;EAC/B;AACF;;AAEA;EACE,kCAAkC;EAClC,kBAAkB;AACpB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE;;IAEE,UAAU;IACV,UAAU;EACZ;;EAEA;IACE,YAAY;IACZ,UAAU;EACZ;AACF;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,+DAA+D;AACjE;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;EACd,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,uBAAuB;EACvB,0BAA0B;EAC1B,2BAA2B;AAC7B;;AAEA;EACE,YAAY;EACZ,gCAAgC;EAChC,yBAAyB;EACzB,4BAA4B;EAC5B,2BAA2B;EAC3B,yBAAyB;EACzB,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;EACzB,wBAAwB;EACxB,0BAA0B;EAC1B,6BAA6B;EAC7B,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,yCAAyC;AAC3C;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,2BAA2B,EAAE,eAAe;EAC5C,yBAAyB,EAAE,WAAW,EACZ,mBAAmB,EACrB,4BAA4B,EAC7B,2BAA2B;EAClD,iBAAiB,EAAE;gFAC2D;AAChF;;AAEA;EACE,uBAAuB;EACvB,iBAAiB;EACjB,sBAAsB;EACtB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE;;IAEE,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;AACF;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE;IACE,qCAAqC;IACrC,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,kBAAkB;IAClB,4BAA4B;EAC9B;AACF;;AAEA;EACE,uBAAuB;EACvB,2BAA2B;EAC3B,2BAA2B;AAC7B;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,oCAAoC;EACpC,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,sCAAsC;EACtC,2CAA2C;AAC7C;;AAEA;;EAEE,yBAAyB;EACzB,WAAW;EACX,2CAA2C;AAC7C;;AAEA;EACE;IACE,2BAA2B;EAC7B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,2BAA2B;EAC7B;AACF;;AAEA;EACE;;;;;;;GAOC;EACD,0BAA0B;EAC1B,sCAAsC;AACxC;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,mBAAmB;EACnB,4BAA4B;EAC5B,0BAA0B;EAC1B,kBAAkB;EAClB,aAAa,EAAE,4BAA4B;AAC7C;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;EACxB,gEAAgE;AAClE;;AAEA;EACE;IACE,kBAAkB;EACpB;;EAEA;;IAEE,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,OAAO;IACP,MAAM;IACN,WAAW;EACb;AACF;;AAEA;EACE,qBAAqB;AACvB","sourcesContent":["#nav-icon1,\r\n#nav-icon2,\r\n#nav-icon3,\r\n#nav-icon4 {\r\n  width: 40px;\r\n  height: 20px;\r\n  position: relative;\r\n  -webkit-transform: rotate(0deg);\r\n  -moz-transform: rotate(0deg);\r\n  -o-transform: rotate(0deg);\r\n  transform: rotate(0deg);\r\n  -webkit-transition: 0.5s ease-in-out;\r\n  -moz-transition: 0.5s ease-in-out;\r\n  -o-transition: 0.5s ease-in-out;\r\n  transition: 0.5s ease-in-out;\r\n  cursor: pointer;\r\n}\r\n\r\n#nav-icon1 span,\r\n#nav-icon3 span,\r\n#nav-icon4 span {\r\n  display: block;\r\n  position: absolute;\r\n  height: 4px;\r\n  width: 100%;\r\n  background: #6b7280;\r\n  border-radius: 9px;\r\n  opacity: 1;\r\n  left: 0;\r\n  -webkit-transform: rotate(0deg);\r\n  -moz-transform: rotate(0deg);\r\n  -o-transform: rotate(0deg);\r\n  transform: rotate(0deg);\r\n  -webkit-transition: 0.25s ease-in-out;\r\n  -moz-transition: 0.25s ease-in-out;\r\n  -o-transition: 0.25s ease-in-out;\r\n  transition: 0.25s ease-in-out;\r\n}\r\n\r\n#nav-icon1 span:nth-child(1) {\r\n  top: 0px;\r\n}\r\n\r\n#nav-icon1 span:nth-child(2) {\r\n  top: 9px;\r\n}\r\n\r\n#nav-icon1 span:nth-child(3) {\r\n  top: 18px;\r\n}\r\n.header-one {\r\n  font-size: 2em;\r\n  font-weight: bold;\r\n  margin: 1em 0;\r\n}\r\n.header-two {\r\n  font-size: 1.5em;\r\n  font-weight: bold;\r\n  margin: 1em 0;\r\n}\r\n.header-three {\r\n  font-size: 1.2em;\r\n  font-weight: bold;\r\n  margin: 1em 0;\r\n}\r\n.header-four {\r\n  font-size: 1.1em;\r\n  font-weight: bold;\r\n  margin: 1em 0;\r\n}\r\n.header-five {\r\n  font-size: 1em;\r\n  font-weight: bold;\r\n  margin: 1em 0;\r\n}\r\n.header-six {\r\n  font-size: 0.85em;\r\n  font-weight: bold;\r\n  margin: 1em 0;\r\n}\r\n.blockquote {\r\n  font-style: italic;\r\n  margin: 1em 0;\r\n  padding-left: 1em;\r\n  border-left: 4px solid gray;\r\n}\r\n.code-block {\r\n  background-color: #f7f7f7;\r\n  padding: 10px;\r\n  border-radius: 4px;\r\n}\r\n.unordered-list-item {\r\n  list-style-type: disc;\r\n  margin-left: 1em;\r\n}\r\n#container-editor a {\r\n  color: #2d67d2 !important;\r\n}\r\n#container-editor a:hover {\r\n  color: #528de0 !important;\r\n}\r\n.ordered-list-item {\r\n  list-style-type: decimal;\r\n  margin-left: 1em;\r\n}\r\n.section {\r\n  margin: 1em 0;\r\n  padding: 1em;\r\n  background-color: #f0f0f0;\r\n}\r\n.article {\r\n  margin: 1em 0;\r\n  padding: 1em;\r\n  background-color: #e0e0e0;\r\n}\r\n#nav-icon1.open span:nth-child(1) {\r\n  top: 9px;\r\n  -webkit-transform: rotate(135deg);\r\n  -moz-transform: rotate(135deg);\r\n  -o-transform: rotate(135deg);\r\n  transform: rotate(135deg);\r\n}\r\n\r\n#nav-icon1.open span:nth-child(2) {\r\n  opacity: 0;\r\n  left: 60px;\r\n}\r\n\r\n#nav-icon1.open span:nth-child(3) {\r\n  top: 9px;\r\n  -webkit-transform: rotate(-135deg);\r\n  -moz-transform: rotate(-135deg);\r\n  -o-transform: rotate(-135deg);\r\n  transform: rotate(-135deg);\r\n}\r\n\r\n.menu-wrapper {\r\n  width: 250px;\r\n  background-color: rgba(255, 255, 255, 1);\r\n  margin-left: -450px;\r\n  opacity: 0;\r\n  -webkit-box-shadow: 10px 10px 6px -8px rgba(161, 136, 119, 0.7);\r\n  transition: all 0.3s ease-in-out;\r\n  border-radius: 2px;\r\n  border-right: 1px solid rgba(0, 0, 0, 0.2);\r\n  border-bottom: 1px solid rgba(0, 0, 0, 0.2);\r\n}\r\n\r\n.menu-open {\r\n  margin-left: -450px;\r\n  opacity: 1;\r\n}\r\n\r\n.maplibregl-ctrl-attrib-inner {\r\n  display: none;\r\n}\r\n\r\n.maplibregl-ctrl-bottom-right {\r\n  display: none;\r\n}\r\n.menu-toggle {\r\n  cursor: pointer;\r\n  z-index: 1000;\r\n  margin: 20px;\r\n  padding: 0px;\r\n  height: 50px;\r\n  width: 50px;\r\n  font-size: 20px;\r\n  color: rgba(0, 0, 0, 0.5);\r\n  font-weight: bold;\r\n  border-radius: 50%;\r\n  background-color: rgba(255, 255, 255, 0.8);\r\n  transform: rotate(0deg);\r\n  transition: all 0.2s ease-in;\r\n  border: 0 none;\r\n}\r\n\r\n.menu-toggle:hover {\r\n  cursor: pointer;\r\n  transform: scale(1.1) rotate(0deg);\r\n  -webkit-box-shadow: 10px 2px 8px -8px rgba(179, 164, 139, 0.6);\r\n}\r\n\r\n.menu-toggle:focus {\r\n  cursor: pointer;\r\n  outline: 0 none;\r\n}\r\n\r\n.links-wrapper {\r\n  margin: 10px;\r\n  padding: 10px;\r\n  text-align: right;\r\n  opacity: 1;\r\n  transition: all 0.7s ease-out;\r\n  transition-delay: 0.1s;\r\n  letter-spacing: 0px;\r\n}\r\n\r\n.links-wrapper-closed {\r\n  padding-top: 10px;\r\n  opacity: 0;\r\n  letter-spacing: -10px;\r\n}\r\n\r\n.link-list {\r\n  padding-top: 30px;\r\n  padding-right: 25px;\r\n  padding-left: 25px;\r\n}\r\n\r\n.link-list li {\r\n  /* list-style-type: none; */\r\n  text-transform: uppercase;\r\n  margin: 0;\r\n  margin-bottom: 30px;\r\n  padding: 3px;\r\n}\r\n\r\n.link-list a {\r\n  text-decoration: none;\r\n  color: rgba(0, 0, 0, 0.804);\r\n  transition: color 0.3s ease;\r\n}\r\n\r\n.social-wrapper a {\r\n  font-size: 24px;\r\n  color: rgba(0, 0, 0, 0.5);\r\n  transition: color 0.3s ease;\r\n}\r\n\r\n.social-wrapper a:hover {\r\n  color: rgba(0, 0, 0, 0.3);\r\n}\r\n\r\n.social-open {\r\n  opacity: 1;\r\n  transition: opacity 0.7s ease-out;\r\n  transition-delay: 0.3s;\r\n}\r\n\r\n.social-closed {\r\n  opacity: 0;\r\n  transition: opacity 0.3s ease-out;\r\n}\r\n\r\n.logo {\r\n  height: 6em;\r\n  padding: 1.5em;\r\n  will-change: filter;\r\n  transition: filter 300ms;\r\n}\r\n\r\n.logo:hover {\r\n  filter: drop-shadow(0 0 2em #646cffaa);\r\n}\r\n\r\n.logo.react:hover {\r\n  filter: drop-shadow(0 0 2em #61dafbaa);\r\n}\r\n\r\n@keyframes logo-spin {\r\n  from {\r\n    transform: rotate(0deg);\r\n  }\r\n\r\n  to {\r\n    transform: rotate(360deg);\r\n  }\r\n}\r\n\r\n@media (prefers-reduced-motion: no-preference) {\r\n  a:nth-of-type(2) .logo {\r\n    animation: logo-spin infinite 20s linear;\r\n  }\r\n}\r\n\r\n.card {\r\n  padding: 2em;\r\n}\r\n\r\n.read-the-docs {\r\n  color: #888;\r\n}\r\n\r\n.border-date-error {\r\n  border-radius: 8px;\r\n  border: #f05252 1px solid !important;\r\n}\r\n\r\n.MuiInputBase-root {\r\n  background-color: \"#FEE2E2 !important\";\r\n}\r\n\r\n.mui-datepicker {\r\n  --mui-datepicker-color: red !important;\r\n}\r\n\r\n.gradient-color {\r\n  background: linear-gradient(\r\n    0deg,\r\n    #000 0%,\r\n    rgba(0, 0, 0, 0.75) 48.44%,\r\n    rgba(0, 0, 0, 0.4) 75.52%,\r\n    rgba(0, 0, 0, 0) 100%\r\n  ) !important;\r\n}\r\n\r\n.image-container {\r\n  position: relative;\r\n}\r\n\r\n.image-container::after {\r\n  border-end-end-radius: 24px;\r\n  border-end-start-radius: 24px;\r\n  content: \"\";\r\n  position: absolute;\r\n  bottom: 0;\r\n  left: 0;\r\n  width: 100%;\r\n  height: 62px;\r\n  background: linear-gradient(\r\n    to bottom,\r\n    rgba(255, 255, 255, 0),\r\n    rgba(0, 0, 0, 1)\r\n  );\r\n}\r\n\r\n.gradient-overlay::after {\r\n  content: \"\";\r\n  position: absolute;\r\n  top: 0;\r\n  left: 0;\r\n  right: 0;\r\n  bottom: 0;\r\n  background: linear-gradient(\r\n    0deg,\r\n    #000 0%,\r\n    rgba(0, 0, 0, 0.75) 48.44%,\r\n    rgba(0, 0, 0, 0.4) 75.52%,\r\n    rgba(0, 0, 0, 0) 100%\r\n  );\r\n  border-radius: 0.75rem;\r\n  pointer-events: none;\r\n}\r\n\r\n.force-0 {\r\n  margin: 0 !important;\r\n}\r\n\r\n.radius {\r\n  border-radius: 40px;\r\n}\r\n\r\n.gerdali {\r\n  border-radius: 16px !important;\r\n}\r\n\r\n.banner-image-filter {\r\n  background-blend-mode: plus-darker;\r\n}\r\n\r\n.banner-image-filter-content {\r\n  mix-blend-mode: plus-darker;\r\n}\r\n\r\n.step-item {\r\n  border-inline-start-width: 1px;\r\n}\r\n\r\n.svg-color-transition {\r\n  transition: fill 3.3s ease;\r\n}\r\n\r\n.fade-enter {\r\n  opacity: 0;\r\n  z-index: 1;\r\n}\r\n\r\n.fade-enter-active {\r\n  opacity: 1;\r\n  transition: opacity 300ms ease-in;\r\n}\r\n\r\n.fade-exit {\r\n  opacity: 1;\r\n}\r\n\r\n.fade-exit-active {\r\n  opacity: 0;\r\n  transition: opacity 300ms ease-in;\r\n}\r\n\r\n.aspect-ratio-16-9 {\r\n  position: relative;\r\n  width: 100%;\r\n  padding-top: 52.25%;\r\n}\r\n\r\n.aspect-ratio-16-9-store-image {\r\n  position: relative;\r\n  width: 100%;\r\n  padding-top: 20.5%;\r\n}\r\n\r\n.mask-svg {\r\n  -webkit-mask-image: url(\"../public/icons/rectangle.svg\");\r\n  -webkit-mask-position: center;\r\n  -webkit-mask-size: cover;\r\n  -webkit-mask-repeat: no-repeat;\r\n\r\n  mask-image: url(\"../public/icons/rectangle.svg\");\r\n  mask-position: center;\r\n  mask-size: cover;\r\n  mask-repeat: no-repeat;\r\n}\r\n\r\n.mask-svg.shrinkgrow {\r\n  animation: mask_svg_shrinkgrow_keys 3s linear 0s normal forwards;\r\n  -moz-animation: mask_svg_shrinkgrow_keys 3s linear 0s normal forwards;\r\n  -webkit-animation: mask_svg_shrinkgrow_keys 3s linear 0s normal forwards;\r\n}\r\n\r\n@keyframes mask_svg_shrinkgrow_keys {\r\n  0% {\r\n    -webkit-mask-position: center;\r\n    -webkit-mask-size: cover;\r\n    mask-position: 0px 0px;\r\n    mask-size: 10000px 0px;\r\n    animation-timing-function: ease-in-out;\r\n  }\r\n\r\n  20% {\r\n    -webkit-mask-position: center;\r\n    -webkit-mask-size: cover;\r\n    mask-position: 0px 0px;\r\n    mask-size: 10000px 0px;\r\n    animation-timing-function: ease-in-out;\r\n  }\r\n\r\n  50% {\r\n    -webkit-mask-position: center;\r\n    -webkit-mask-size: cover;\r\n    mask-position: 0px 0px;\r\n    mask-size: 10000px 380px;\r\n    animation-timing-function: ease-in-out;\r\n  }\r\n\r\n  100% {\r\n    -webkit-mask-position: center;\r\n    -webkit-mask-size: cover;\r\n    mask-position: 0px 0px;\r\n    mask-size: 10000px 10000px;\r\n    animation-timing-function: ease-in-out;\r\n  }\r\n}\r\n\r\n#search-dropdown:focus {\r\n  border: 1px solid #d1d5db;\r\n  outline: none;\r\n  border-radius: 10px 0px 0px 10px;\r\n  background-color: #f3f4f6;\r\n}\r\n\r\n#search-dropdown {\r\n  border: 1px solid #d1d5db;\r\n}\r\n\r\n.full-screen {\r\n  z-index: 2;\r\n  height: 100vh !important;\r\n  background-color: #a59e9e4a;\r\n  position: absolute;\r\n  top: 0;\r\n  right: 0;\r\n  bottom: 0;\r\n  left: 0;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  pointer-events: none;\r\n}\r\n\r\n.min-h-screen-90px {\r\n  min-height: calc(100vh - 90px);\r\n}\r\n\r\n.max-h-screen-150px {\r\n  max-height: calc(100vh - 150px);\r\n}\r\n\r\n.rounded-bb-ends {\r\n  position: relative;\r\n}\r\n\r\n.rounded-bb-ends::after {\r\n  content: \"\";\r\n  position: absolute;\r\n  bottom: 0;\r\n  left: 0;\r\n  width: 100%;\r\n  height: 4px;\r\n  background: #477cd1;\r\n  border-bottom-left-radius: 80px;\r\n  border-bottom-right-radius: 80px;\r\n  border-top-right-radius: 80px;\r\n  border-top-left-radius: 80px;\r\n}\r\n\r\n.min-h-screen-min {\r\n  min-height: calc(100vh + 150px);\r\n}\r\n\r\n.my-confirm-button {\r\n  border: none !important;\r\n  border-radius: 8px !important;\r\n  outline-style: none !important;\r\n  color: white !important;\r\n  outline: none !important;\r\n}\r\n\r\n.my-confirm-button:focus {\r\n  border: none !important;\r\n  outline: none !important;\r\n}\r\n\r\n.my-cancel-button {\r\n  border-radius: 8px !important;\r\n  color: #1f2a37 !important;\r\n  border: #e5e7eb 1px solid !important;\r\n}\r\n\r\n.swal2-popup .swal2-styled:focus {\r\n  box-shadow: none !important;\r\n}\r\n\r\n.width-full-mobile-cheque {\r\n  width: calc(100vw - 50px);\r\n}\r\n\r\n.w-dashboard {\r\n  width: calc(100vw - 50px);\r\n}\r\n\r\n@media screen and (min-width: 536px) {\r\n  .w-dashboard-table-mobile {\r\n    width: calc(100vw - 300px) !important;\r\n    max-width: 1800px !important;\r\n    margin-top: 32px !important;\r\n    margin-inline: auto;\r\n    /* background-color: blue; */\r\n  }\r\n}\r\n\r\n@media screen and (max-width: 768px) {\r\n  .w-dashboard-table-mobile {\r\n    width: calc(100vw) !important;\r\n    /* background-color: blue; */\r\n  }\r\n}\r\n\r\n@media screen and (min-width: 536px) {\r\n  .w-dashboard-table-mobile-header {\r\n    width: calc(100vw - 400px) !important;\r\n    max-width: 1800px !important;\r\n    /* margin-top: 32px !important; */\r\n    /* background-color: blue; */\r\n  }\r\n}\r\n\r\n@media screen and (max-width: 768px) {\r\n  .w-dashboard-table-mobile-header {\r\n    width: calc(90vw) !important;\r\n    /* background-color: blue; */\r\n  }\r\n}\r\n\r\n@media screen and (min-width: 536px) {\r\n  .w-dashboard-dashbord-step {\r\n    width: calc(100vw - 300px);\r\n    max-width: 1200px;\r\n    /* background-color: blue; */\r\n  }\r\n}\r\n\r\n@media screen and (max-width: 768px) {\r\n  .w-dashboard-dashbord-step {\r\n    width: calc(90vw);\r\n    /* background-color: blue; */\r\n  }\r\n}\r\n\r\n.fulltext {\r\n  white-space: nowrap;\r\n}\r\n\r\n.truncatetext:hover + .fulltext,\r\n.fulltext:hover {\r\n  display: inline;\r\n  white-space: normal;\r\n  white-space: nowrap;\r\n}\r\n\r\n.truncatetext:hover {\r\n  white-space: nowrap;\r\n}\r\n\r\n.p-checkbox-icon {\r\n  color: white;\r\n}\r\n\r\n.p-checkbox-box {\r\n  border: #c3c3c3 1px solid !important;\r\n  border-radius: 6px;\r\n}\r\n\r\n.p-checkbox .p-highlight {\r\n  color: #1d65f2;\r\n  background-color: #1d65f2 !important;\r\n  border: none !important;\r\n  border-radius: 6px;\r\n}\r\n\r\n.p-radiobutton-box:focus {\r\n  border: none !important;\r\n}\r\n\r\n.p-radiobutton-box {\r\n  background-color: #e1e1e1 !important;\r\n}\r\n\r\n.p-radiobutton-icon {\r\n  background-color: rgb(29, 89, 228) !important;\r\n  background-image: none !important;\r\n}\r\n\r\n.p-highlight {\r\n  border: none !important;\r\n}\r\n\r\n.p-dropdown-items-wrapper {\r\n  background-color: #e7e7e73b !important; /* Light gray background */\r\n  color: #000000; /* Dark text color */\r\n  border-radius: 8px !important;\r\n  padding-inline: 10px !important;\r\n  border-bottom: 3px;\r\n}\r\n\r\n.p-dropdown-items-wrapper:hover {\r\n  background-color: #e7e7e73b !important; /* Slightly darker on hover */\r\n  color: #000; /* Black text color on hover */\r\n}\r\n\r\n.p-focus {\r\n  border: none !important;\r\n}\r\n\r\n.p-column-header-content {\r\n  display: flex;\r\n  align-items: start;\r\n  justify-content: center;\r\n}\r\n\r\n@keyframes pulseBorder {\r\n  0% {\r\n    border: 2px solid transparent;\r\n  }\r\n\r\n  50% {\r\n    border: 3px solid #3498db;\r\n  }\r\n\r\n  100% {\r\n    border: 2px solid transparent;\r\n  }\r\n}\r\n\r\n.animated-border {\r\n  animation: pulseBorder 1s infinite;\r\n  border-radius: 8px;\r\n}\r\n\r\ntr td:not(.p-selection-column):first-child {\r\n  padding: 0;\r\n}\r\n\r\nth {\r\n  text-align: center;\r\n  white-space: nowrap;\r\n}\r\n\r\n@keyframes wink {\r\n  0%,\r\n  100% {\r\n    opacity: 1;\r\n    scale: 1.1;\r\n  }\r\n\r\n  50% {\r\n    opacity: 0.8;\r\n    scale: 0.9;\r\n  }\r\n}\r\n\r\n.animate-wink {\r\n  animation: wink 1.5s infinite;\r\n}\r\n\r\n.center-text-input {\r\n  text-align: center;\r\n}\r\n\r\n.p-paginator-element svg {\r\n  transform: rotate(180deg);\r\n}\r\n\r\n[data-p-frozen-column=\"true\"] {\r\n  left: 0px !important;\r\n}\r\n\r\n.test-gradient {\r\n  background: linear-gradient(180deg, #ffdc97 -25%, #ffea30 100%);\r\n}\r\n\r\n.tooltip {\r\n  position: relative;\r\n  display: inline-block;\r\n}\r\n\r\n.tooltip .tooltiptext {\r\n  visibility: hidden;\r\n  width: fit-content;\r\n  white-space: nowrap;\r\n  background-color: black;\r\n  color: #fff;\r\n  text-align: center;\r\n  border-radius: 6px;\r\n  padding: 5px 0;\r\n  position: absolute;\r\n  z-index: 1;\r\n}\r\n\r\n.tooltip:hover .tooltiptext {\r\n  visibility: visible;\r\n}\r\n\r\n.scrollable-container {\r\n  overflow-x: auto;\r\n  white-space: nowrap;\r\n  cursor: grab;\r\n}\r\n\r\n.scrollable-container:active {\r\n  cursor: grabbing;\r\n}\r\n\r\n.creditor-loan-component {\r\n  display: inline-block;\r\n}\r\n\r\n.height-hc {\r\n  height: 52px !important;\r\n  font-size: 20px !important;\r\n  font-weight: 400 !important;\r\n}\r\n\r\n.no-border {\r\n  border: none;\r\n  border-color: #bbbbbb !important;\r\n  padding-top: 0 !important;\r\n  padding-bottom: 0 !important;\r\n  margin-top: 30px !important;\r\n  color: #bbbbbb !important;\r\n  width: 60px !important;\r\n  height: 60px !important;\r\n}\r\n\r\n.title-padding {\r\n  padding-top: 0 !important;\r\n  margin-top: 0 !important;\r\n  font-size: 16px !important;\r\n  font-weight: 400px !important;\r\n  color: #6b7280 !important;\r\n}\r\n\r\n.input-no-focus-border:focus {\r\n  outline: none;\r\n  /* border: none; */\r\n  box-shadow: none;\r\n  border-bottom: 1px black solid !important;\r\n}\r\n\r\n.h5-important {\r\n  height: 5px !important;\r\n}\r\n\r\n.noselect {\r\n  -webkit-touch-callout: none; /* iOS Safari */\r\n  -webkit-user-select: none; /* Safari */\r\n  -khtml-user-select: none; /* Konqueror HTML */\r\n  -moz-user-select: none; /* Old versions of Firefox */\r\n  -ms-user-select: none; /* Internet Explorer/Edge */\r\n  user-select: none; /* Non-prefixed version, currently\r\n                                  supported by Chrome, Edge, Opera and Firefox */\r\n}\r\n\r\n.selector {\r\n  -webkit-user-drag: none;\r\n  user-select: none;\r\n  -moz-user-select: none;\r\n  -webkit-user-select: none;\r\n  -ms-user-select: none;\r\n}\r\n\r\n@keyframes wink-color {\r\n  0%,\r\n  100% {\r\n    color: #477cd1;\r\n  }\r\n\r\n  50% {\r\n    color: #031203;\r\n  }\r\n}\r\n\r\n.hover-wink-color:hover {\r\n  animation: wink-color 0.5s infinite;\r\n}\r\n\r\n@media screen and (min-width: 536px) {\r\n  .w-dashboard-table-mobile-in-tasvie {\r\n    width: calc(100vw - 300px) !important;\r\n    max-width: 1400px;\r\n  }\r\n}\r\n\r\n@media screen and (max-width: 768px) {\r\n  .w-dashboard-table-mobile-in-tasvie {\r\n    width: calc(100vw);\r\n    /* background-color: blue; */\r\n  }\r\n}\r\n\r\n.forceheight {\r\n  height: 60px !important;\r\n  font-weight: 900 !important;\r\n  font-size: large !important;\r\n}\r\n\r\n.borderforce {\r\n  border: red 2px solid !important;\r\n}\r\n\r\n.border-radius-force {\r\n  border-radius: 8rem !important;\r\n}\r\n\r\n.h-fullll {\r\n  height: 100% !important;\r\n}\r\n\r\n.custom-dropdown {\r\n  width: 100%;\r\n  border: 2px solid #d4d4d4 !important;\r\n  border-radius: 8px;\r\n  font-size: 16px;\r\n}\r\n\r\n.custom-panel .p-dropdown-item {\r\n  color: #333;\r\n  padding: 10px;\r\n  transition: background-color 0.3s ease;\r\n  border-bottom: #a2b8e4 1px solid !important;\r\n}\r\n\r\n.custom-panel .p-dropdown-item.p-highlight,\r\n.custom-panel .p-dropdown-item:hover {\r\n  background-color: #93bde4;\r\n  color: #fff;\r\n  border-bottom: #315c85 5px solid !important;\r\n}\r\n\r\n@keyframes gradientBG {\r\n  0% {\r\n    background-position: 0% 50%;\r\n  }\r\n  50% {\r\n    background-position: 100% 50%;\r\n  }\r\n  100% {\r\n    background-position: 0% 50%;\r\n  }\r\n}\r\n\r\n.animated-bg {\r\n  background: linear-gradient(\r\n    60deg,\r\n    #b9d4fc,\r\n    #ffffff,\r\n    #ddedfe,\r\n    #b9d4fc,\r\n    #ffffff\r\n  );\r\n  background-size: 300% 300%;\r\n  animation: gradientBG 3s ease infinite;\r\n}\r\n\r\n.carousel-container {\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  perspective: 1000px;\r\n  transform-style: preserve-3d;\r\n  transition: transform 0.5s;\r\n  position: relative;\r\n  height: 300px; /* Adjust height as needed */\r\n}\r\n\r\n.carousel-item {\r\n  position: absolute;\r\n  transform-origin: center;\r\n  transform: rotateY(calc(var(--index) * 90deg)) translateZ(300px);\r\n}\r\n\r\n@media print-add {\r\n  body * {\r\n    visibility: hidden;\r\n  }\r\n\r\n  .print-add-content,\r\n  .print-add-content * {\r\n    visibility: visible;\r\n  }\r\n\r\n  .print-add-content {\r\n    position: absolute;\r\n    left: 0;\r\n    top: 0;\r\n    width: 100%;\r\n  }\r\n}\r\n\r\n.p-multiselect-clear-icon {\r\n  right: 90% !important;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
